import type { BookingDetailsParticipant, FlightInformation, FlightLeg } from '../../../domain/types'

export interface FlightGroup {
  key: string
  participantIds: number[]
  inbound: FlightLeg[]
  outbound: FlightLeg[]
}

export function getParticipantIdsKey(ids: number[]): string {
  return [...ids].sort((a, b) => a - b).join('-')
}

export function groupFlightsByParticipants(flights: FlightInformation[]): FlightGroup[] {
  const groups = new Map<string, FlightGroup>()

  flights.forEach((flight) => {
    const key = getParticipantIdsKey(flight.participantIds)
    const existing = groups.get(key)

    if (existing) {
      if (flight.outbound?.length) {
        existing.outbound.push(...flight.outbound)
      }
      if (flight.inbound?.length) {
        existing.inbound.push(...flight.inbound)
      }
      return
    }

    groups.set(key, {
      key,
      participantIds: [...flight.participantIds],
      outbound: flight.outbound?.length ? [...flight.outbound] : [],
      inbound: flight.inbound?.length ? [...flight.inbound] : [],
    })
  })

  return Array.from(groups.values())
}

export function formatParticipantNames(
  ids: number[],
  participants: Record<string, BookingDetailsParticipant>,
): string {
  return ids
    .map(id => participants[String(id)])
    .filter((participant): participant is BookingDetailsParticipant => Boolean(participant))
    .map(participant => `${participant.firstName} ${participant.lastName}`)
    .join(', ')
}
